import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import api from "../../api/api";
import { red, blue, green, purple } from "@mui/material/colors";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {language_change, usertype_change } from "./ExtraTopic.Slice";
import {
  getExtraTopicThunk,
  createExtraTopicThunk,
  updateExtraTopicThunk,
  deleteExtraTopicThunk,
} from "./ExtraTopic.Thunk";

const ExtraTopicPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event,  categoryId, categoryName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    // setRecordId(_id);
    setSelectedSkillsetId(categoryId);
    setSelectedSkillsetName(categoryName);
  };
  // const handleVertMenuClose = () => {
  //   setAnchorEl(null);
  // };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------


    // -------------- Card-item vertical menu ---------------

  

    const handleVertMenuClose = () => {
      setAnchorEl(null);
    };
    // ---------------------------------------------
  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/extrapage");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];

  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  // ------------ dropdowns on change ----------------
  const usertype_select_onchange = (event) => {
    dispatch(usertype_change(event.target.value));
  };

  const language_select_onchange = (event) => {
    dispatch(language_change(event.target.value));
  };

  const data = useSelector((state) => state.ExtraTopicSlice.topic);

  // ------------ Load   & skill ----------------


  const topicId = useSelector(
    (state) => state.ExtraTopicSlice.topicId
  );

  const topicName = useSelector(
    (state) => state.ExtraTopicSlice.topicName
  );
  const topicOrder = useSelector(
    (state) => state.ExtraTopicSlice.topicOrder
  );
  const duration = useSelector(
    (state) => state.ExtraTopicSlice.duration
  );

  const usertype = useSelector((state) => state.ExtraTopicSlice.usertype);
  console.log("usertype-->", usertype);
  const language = useSelector((state) => state.ExtraTopicSlice.language);
  console.log("language-->",language);
  const topic = useSelector((state) => state.ExtraTopicSlice.topic);
 console.log("topic--->", topic);
  // const disable_content_button = useSelector(
  //   (state) => state.TeacherCategorySlice.disable_content_button
  // );

  useEffect(() => {
    const load_  = () => {
      const params = { usertype, language };
      // console.log("params-->", params);
      dispatch(getExtraTopicThunk(params));
    };
    load_ (); 
  }, [dispatch, usertype, language]);

    // For State Declaration
    const [show, setShow] = useState(false);
  
   //On Modal close and open

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);
 
   const [showUpdate, setShowUpdate] = useState(false);

  // -----------------------------------------------

  const [changetopicName, setChangetopicName] = useState("");
  const handleChangetopicName = (event) => {
    setChangetopicName(event.target.value);
  };
  const [changetopicOrder, setChangetopicOrder] = useState("");
  const handleChangetopicOrder = (event) => {
    setChangetopicOrder(event.target.value);
  };
  const [changeduration, setChangeduration] = useState("");
  const handleChangeduration = (event) => {
    setChangeduration(event.target.value);
  };

  const [isLoading, setIsLoading] = useState(false);
  const dataa = {
    topicId: new Date().getTime(),

    topicName: changetopicName,
    topicOrder: changetopicOrder,
    duration: changeduration,
    language: "od",
    usertype: usertype,
    // category: categoryId,
  };
  const handleSave = () => {
    setShow(false);
    setIsLoading(true);
    toast.success("Changes made successfully");
    dispatch(createExtraTopicThunk(dataa)).then((res) => {
      const params = { usertype };
      dispatch(getExtraTopicThunk(params));
      
    });
  };
  const [updateData, setUpdateData] = useState({
    // _id: "",
    topicId: new Date().getTime(),
    topicName: "",
    topicOrder: "",
    duration: "",
    usertype: usertype,
    language: "od",
  });
console.log("updateData-->", updateData);

const[updateExtra,setUpdateExtra] = useState([])
  const handleShowUpdate = (eachskill) => {
    setUpdateExtra(eachskill);
    setUpdateData({
      // _id: eachskill._id,
      topicId: eachskill.topicId,
      topicName: eachskill.topicName,
      topicOrder: eachskill.topicOrder,
      duration: eachskill.duration,
    //   usertype: usertype,
    // language: "od",
    });
    setShowUpdate(true);
  };

  const handleUpdateChanges = () => {
    console.log("updateExtra-->", updateExtra);
    api.put(`updateTchExtraModulesTopic`, updateData).then(
      (response) => {
        //  setResult(response.data);
console.log("response.data-->", response.data)
        if (response.data.status === "success") {
          toast.success("Changes made successfully");
          const params = { usertype, language};
          dispatch(getExtraTopicThunk(params));
        }
      },
      (err) => {
        console.log(err);
        toast.error("Enter a valid Topic");
      }
    );
    setShowUpdate(false);
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  // ----------- create, update delete button click ----------

  const delete_content_button_click = (topicId) => {
    console.log("topicId-->", topicId);
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteExtraTopicThunk(topicId)).then(() => {
          const params = {usertype, language};
          dispatch(getExtraTopicThunk(params));
          toast.success("Changes made successfully");
        });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="Extra Topic" />

        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120, marginTop: 10 }} size="small">
          <InputLabel id="demo-select-small">Usertype</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={usertype}
            label="Language"
            onChange={usertype_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{
            minWidth: 80,
            alignItem: "right",
            backgroundColor: "blue",
            color: "black",
          }}
          size="small">
          <UndoIcon style={{ color: "orange" }}></UndoIcon>
          Back
        </Button>
      </div>
    <div>
        <div>
          <Button
            onClick={handleShow}
            variant="contained"
            sx={{ marginTop: 3, float: "left" }}
            // disabled={disable_content_button}
            >
            create new topic
            {/* <AddIcon /> */}
          </Button>
          <br />
          <br />
          <br />

          <Modal
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={style}>
              <br />
              <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2} style={{ marginTop: 12 }}>
                    <Grid item xs={3} md={3}>
                      <TextField
                        id="outlined-basic"
                        label="Order"
                        variant="outlined"
                         onChange={handleChangetopicOrder}
                      />
                    </Grid>
                    <Grid item xs={9} md={9}>
                      <TextField
                        id="outlined-basic"
                        label="topic"
                        variant="outlined"
                         onChange={handleChangetopicName}
                      />
                    </Grid>
                    <Grid item xs={9} md={9}>
                      <TextField
                        id="outlined-basic"
                        label="duration"
                        variant="outlined"
                         onChange={handleChangeduration}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </FormControl>

              <Button
                variant="outlined"
                style={{ marginLeft: 12 }}
                onClick={handleClose}>
                Close
              </Button>
              <Button variant="contained" 
               onClick={handleSave}
              >
                Save
              </Button>
            </Box>
          </Modal>
        </div>
        <br />
        <table style={{backgroundColor: "lightblue", width: "492px"}}>
          <tr>
            <th style={{width: "50px"}}>
              Order
            </th>
            <th style={{width: "110px"}}>
              Topic
            </th>
            <th style={{width: "190px"}}>
              Duration
            </th>
            <th style={{width: "140px"}}>
              Action
            </th>
          </tr>
        </table>
        <table style={{ border: "1px solid blue" }}>
          
          {topic.map((eachskill) => (
            <thead>
              <tbody>
                <tr>
                  <td style={{width: "60px", wordBreak: "break-all"}}>{eachskill.topicOrder}</td>
                  <td style={{width: "180px", wordBreak: "break-all"}}>{eachskill.topicName}</td>
                  <td style={{width: "40px", wordBreak: "break-all"}}>{eachskill.duration}</td>
                  <td>
                  <Button
                    // variant="contained"
                     style={{ marginLeft: 65 }}
                    // style={{width: "50px"}}
                     onClick={() => handleShowUpdate(eachskill)}
                    >
                  <EditIcon style={{ color: "blue" }}></EditIcon>
                  </Button>
                </td>
                <td>
                  <Button
                    // variant="contained"
                    // style={{width: "50px"}}
                     onClick={() => delete_content_button_click(eachskill)}
                    // sx={{ marginLeft: 30 }}
                    >
                    <DeleteIcon  style={{ color: "red" }}></DeleteIcon>
                  </Button>
                </td>
                </tr>
                
            
              </tbody>
            </thead>
          ))}
        </table>
        <Modal
          open={showUpdate}
          onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description">
          <Box sx={style}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
             

              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} style={{ marginTop: 12 }}>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Order"
                      variant="outlined"
                      value={updateData.topicOrder}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          topicOrder: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Topic"
                      variant="outlined"
                      value={updateData.topicName}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          topicName: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      id="outlined-basic"
                      label="Duration"
                      variant="outlined"
                      value={updateData.duration}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          duration: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}>
              Close
            </Button>
            <Button variant="contained" 
             onClick={handleUpdateChanges}
            >
              Update
            </Button>
          </Box>
        </Modal>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default ExtraTopicPage;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};